// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './KmFeedback.css';

// const KmFeedback = () => {
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [categoryData, setCategoryData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [submittedRange, setSubmittedRange] = useState(null);
//     const [filterBy, setFilterBy] = useState("");
//     const [liked, setLiked] = useState([]);
//     const [disliked, setDisliked] = useState([]);
//     const [categoryDataBlock, setCategoryDataBlock] = useState([]);
//     const [classificationDataBlock, setClassificationDataBlock] = useState([]);
//     const [likedCategoryFilter, setLikedCategoryFilter] = useState([]);
//     const [dislikedCategoryFilter, setDislikedCategoryFilter] = useState([]);
//     const [viewsCategoryFilter, setViewsCategoryFilter] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState('All');

//     const [showName, setshowName] = useState(true);
//     const [showClassification, setClassification] = useState(true);
//     const [showCatagory, setShowCatagory] = useState(true);
//     const [showCount, setShowCount] = useState(true);

//     const filter = ["Views", "Likes", "Dislikes"];

//     const handelFilter = (e) => {
//         setFilterBy(e.target.value);
//         setSelectedCategory('All');  // Reset category filter when switching between Views/Likes/Dislikes
//     };

//     const fetchData = async (start, end) => {
//         setIsLoading(true);
//         try {
//             const response = await axios.post('/api/kmanalysis', { startDate: start, endDate: end });
//             const { allDataFromMongo, satisfied, notsatisfied, categoryData, classificationData } = response.data;
//             setCategoryData(allDataFromMongo);
//             setLiked(satisfied);
//             setDisliked(notsatisfied);
//             setCategoryDataBlock(categoryData);
//             setClassificationDataBlock(classificationData);
//         } catch (error) {
//             alert('Failed to fetch category data.');
//         } finally {
//             setIsLoading(false);
//             setFilterBy(filter[0]);
//         }
//     };

//     useEffect(() => {
//         if (startDate && endDate) {
//             fetchData(startDate, endDate);
//             setSubmittedRange(`${startDate} - ${endDate}`);
//         }
//     }, [startDate, endDate]);

//     useEffect(() => {
//         if (liked.length > 0 || disliked.length > 0 || categoryData.length > 0) {
//             const likedCategories = ['All', ...new Set(liked.map(e => e.data.category_for_analytics || '-'))];
//             const dislikedCategories = ['All', ...new Set(disliked.map(e => e.data.category_for_analytics || '-'))];
//             const viewsCategories = ['All', ...new Set(categoryData.map(item => item.data.category_for_analytics || '-'))];

//             setLikedCategoryFilter(likedCategories);
//             setDislikedCategoryFilter(dislikedCategories);
//             setViewsCategoryFilter(viewsCategories);
//         }
//     }, [liked, disliked, categoryData]);

//     const processCategoryData = (isDownload = false) => {
//         const viewsData = [];
//         const likedData = [];
//         const dislikedData = [];

//         liked.forEach((x) => {
//             likedData.push({
//                 name: x.name,
//                 link: x.data.link,
//                 like: x.like,
//                 classification: x.data.category_for_analytics || "-",
//                 category: x.data.category
//             });
//         });

//         disliked.forEach((x) => {
//             dislikedData.push({
//                 name: x.name,
//                 link: x.data.link,
//                 disslike: x.disslike,
//                 classification: x.data.category_for_analytics || "-",
//                 category: x.data.category
//             });
//         });

//         categoryData.forEach((categoryItem) => {
//             viewsData.push({
//                 name: categoryItem.data.name,
//                 link: categoryItem.data.link,
//                 count: categoryItem.count,
//                 classification: categoryItem.data.category_for_analytics || "-",
//                 category: categoryItem.data.category
//             });
//         });

//         if (isDownload) {
//             return { viewsData, dislikedData, likedData, categoryDataBlock, classificationDataBlock };
//         } else {
//             const filterByCategory = (data) => {
//                 return selectedCategory && selectedCategory !== 'All'
//                     ? data.filter(item => item.classification === selectedCategory)
//                     : data;
//             };

//             if (filterBy === "Likes") {
//                 return filterByCategory(likedData);
//             } else if (filterBy === "Dislikes") {
//                 return filterByCategory(dislikedData);
//             } else {
//                 return filterByCategory(viewsData);
//             }
//         }
//     };

//     const tableData = processCategoryData(false);

//     const handelCategoryFilter = (e) => {
//         setSelectedCategory(e.target.value);
//     };

//     const handleDownloadExcel = async () => {
//         if (startDate && endDate) {
//             const { viewsData, dislikedData, likedData } = processCategoryData(true);
//             try {
//                 const response = await fetch(`/api/download`, {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify({ viewsData, dislikedData, likedData, startDate, endDate, categoryData: categoryDataBlock, classificationData: classificationDataBlock }),
//                 });

//                 if (!response.ok) {
//                     throw new Error('Network response was not ok');
//                 }

//                 const blob = await response.blob();
//                 const url = window.URL.createObjectURL(blob);
//                 const a = document.createElement('a');
//                 a.href = url;
//                 a.download = `From_${startDate}_to_${endDate}.xlsx`;
//                 document.body.appendChild(a);
//                 a.click();
//                 document.body.removeChild(a);
//                 window.URL.revokeObjectURL(url);

//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         } else {
//             alert('Please select both start and end dates.');
//         }
//     };

//     return (
//         <>
//             <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop: "20px" }}>
//                 KM Feedback Dashboard
//             </h1>
//             <div className="container">
//                 <div className="datepickercontainer">
//                     <div className="date-picker">
//                         <div className="startdate">
//                             <label htmlFor="start-date-picker">Start date:</label>
//                             <input
//                                 type="date"
//                                 id="start-date-picker"
//                                 value={startDate}
//                                 onChange={(e) => setStartDate(e.target.value)}
//                             />
//                         </div>
//                         <div className="enddate">
//                             <label htmlFor="end-date-picker">End date:</label>
//                             <input
//                                 type="date"
//                                 id="end-date-picker"
//                                 value={endDate}
//                                 onChange={(e) => setEndDate(e.target.value)}
//                             />
//                         </div>
//                     </div>
//                     <button disabled={!startDate && !endDate} onClick={handleDownloadExcel}>Download Excel</button>
//                 </div>

//                 {isLoading && <p>Loading...</p>}

//                 {submittedRange &&
//                     <div className='drop'>
//                         <h4>Filter Data By:</h4>
//                         <div className="selector">
//                             <select onChange={handelFilter} value={filterBy}>
//                                 {filter.map((names, index) => (
//                                     <option key={index} value={names}>
//                                         {names}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                 }
//                 <div style={{ height: "20px" }}></div>
//                 {submittedRange &&
//                     <div className='drop'>
//                         <h4>Choose Category:</h4>
//                         <div className="selector">
//                             <select onChange={handelCategoryFilter} value={selectedCategory}>
//                                 {filterBy === "Likes" && likedCategoryFilter.map((names, index) => (
//                                     <option key={index} value={names}>
//                                         {names}
//                                     </option>
//                                 ))}
//                                 {filterBy === "Dislikes" && dislikedCategoryFilter.map((names, index) => (
//                                     <option key={index} value={names}>
//                                         {names}
//                                     </option>
//                                 ))}
//                                 {filterBy === "Views" && viewsCategoryFilter.map((names, index) => (
//                                     <option key={index} value={names}>
//                                         {names}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                 }

//                 <div className="category-data">
//                     {submittedRange && <h4>{submittedRange}</h4>}
//                     <div className="togglescreen">
//                         <label>
//                             <input
//                                 type="checkbox"
//                                 checked={showName}
//                                 onChange={() => setshowName(!showName)}
//                             />
//                             Show Name
//                         </label>
//                         <label>
//                             <input
//                                 type="checkbox"
//                                 checked={showCatagory}
//                                 onChange={() => setShowCatagory(!showCatagory)}
//                             />
//                             Show Category
//                         </label>
//                         <label>
//                             <input
//                                 type="checkbox"
//                                 checked={showClassification}
//                                 onChange={() => setClassification(!showClassification)}
//                             />
//                             Show Classification
//                         </label>
//                         <label>
//                             <input
//                                 type="checkbox"
//                                 checked={showCount}
//                                 onChange={() => setShowCount(!showCount)}
//                             />
//                             Show {filterBy || "Views"}
//                         </label>
//                     </div>

//                     <div className="table-container">
//                         <table className="category-table">
//                             <thead>
//                                 <tr>
//                                     {/* <th>Sr. No.</th> */}
//                                     {showName && <th>Name</th>}
//                                     {showCatagory && <th>Category</th>}
//                                     {showClassification && <th>Classification</th>}
//                                     {showCount && <th>{filterBy || "Views"}</th>}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tableData.length > 0 ? (
//                                     tableData.map((category, index) => (
//                                         <tr key={index}>
//                                             {/* <td>{index + 1}</td> */}
//                                             {showName && <td><a href={category.link} target="_blank" rel="noopener noreferrer">{category.name}</a></td>}
//                                             {showCatagory && <td>{category.classification}</td>}
//                                             {showClassification && <td>{category.category}</td>}
//                                             {showCount &&
//                                                 <td>
//                                                     {filterBy === "Likes" ? category.like : filterBy === "Dislikes" ? category.disslike : category.count}
//                                                 </td>
//                                             }
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan={3}>No data available.</td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//                 <div style={{ height: "150px" }}></div>
//             </div>
//         </>
//     );
// };

// export default KmFeedback;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './KmFeedback.css';

const KmFeedback = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [categoryData, setCategoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [submittedRange, setSubmittedRange] = useState(null);
    const [filterBy, setFilterBy] = useState("");
    const [liked, setLiked] = useState([]);
    const [disliked, setDisliked] = useState([]);
    const [categoryDataBlock, setCategoryDataBlock] = useState([]);
    const [classificationDataBlock, setClassificationDataBlock] = useState([]);
    const [likedCategoryFilter, setLikedCategoryFilter] = useState([]);
    const [dislikedCategoryFilter, setDislikedCategoryFilter] = useState([]);
    const [viewsCategoryFilter, setViewsCategoryFilter] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');

    const [likedClassificationFilter, setLikedClassificationFilter] = useState([]);
    const [dislikedClassificationFilter, setDislikedClassificationFilter] = useState([]);
    const [viewsClassificationFilter, setViewsClassificationFilter] = useState([]);
    const [selectedClassification, setSelectedClassification] = useState('All');


    const [showName, setshowName] = useState(true);
    const [showClassification, setClassification] = useState(true);
    const [showCatagory, setShowCatagory] = useState(true);
    const [showCount, setShowCount] = useState(true);

    const filter = ["Views", "Likes", "Dislikes"];

    const handelFilter = (e) => {
        setFilterBy(e.target.value);
        setSelectedCategory('All');
        setSelectedClassification('All');
    };

    const handelClassificationFilter = (e) => {
        setSelectedClassification(e.target.value);
    };


    const fetchData = async (start, end) => {
        setIsLoading(true);
        try {
            const response = await axios.post('/api/kmanalysis', { startDate: start, endDate: end });
            const { allDataFromMongo, satisfied, notsatisfied, categoryData, classificationData } = response.data;
            setCategoryData(allDataFromMongo);
            setLiked(satisfied);
            setDisliked(notsatisfied);
            setCategoryDataBlock(categoryData);
            setClassificationDataBlock(classificationData);
        } catch (error) {
            alert('Failed to fetch category data.');
        } finally {
            setIsLoading(false);
            setFilterBy(filter[0]);
        }
    };

    useEffect(() => {
        if (startDate && endDate) {
            fetchData(startDate, endDate);
            setSubmittedRange(`${startDate} - ${endDate}`);
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (liked.length > 0 || disliked.length > 0 || categoryData.length > 0) {
            //catogery 
            const likedCategories = ['All', ...new Set(liked.map(e => e.data.category_for_analytics || '-'))];
            const dislikedCategories = ['All', ...new Set(disliked.map(e => e.data.category_for_analytics || '-'))];
            const viewsCategories = ['All', ...new Set(categoryData.map(item => item.data.category_for_analytics || '-'))];

            setLikedCategoryFilter(likedCategories);
            setDislikedCategoryFilter(dislikedCategories);
            setViewsCategoryFilter(viewsCategories);

            //classifiction
            const likedClassifications = ['All', ...new Set(liked.map(e => e.data.category).filter(Boolean))];
            const dislikedClassifications = ['All', ...new Set(disliked.map(e => e.data.category).filter(Boolean))];
            const viewsClassifications = ['All', ...new Set(categoryData.map(item => item.data.category).filter(Boolean))];

            setLikedClassificationFilter(likedClassifications);
            setDislikedClassificationFilter(dislikedClassifications);
            setViewsClassificationFilter(viewsClassifications);
        }
    }, [liked, disliked, categoryData]);

    const processCategoryData = (isDownload = false) => {
        const viewsData = [];
        const likedData = [];
        const dislikedData = [];

        liked.forEach((x) => {
            likedData.push({
                name: x.name,
                link: x.data.link,
                like: x.like,
                classification: x.data.category_for_analytics || "-",
                category: x.data.category
            });
        });

        disliked.forEach((x) => {
            dislikedData.push({
                name: x.name,
                link: x.data.link,
                disslike: x.disslike,
                classification: x.data.category_for_analytics || "-",
                category: x.data.category
            });
        });

        categoryData.forEach((categoryItem) => {
            viewsData.push({
                name: categoryItem.data.name,
                link: categoryItem.data.link,
                count: categoryItem.count,
                classification: categoryItem.data.category_for_analytics || "-",
                category: categoryItem.data.category
            });
        });

        if (isDownload) {
            return { viewsData, dislikedData, likedData, categoryDataBlock, classificationDataBlock };
        } else {
            const filterByCategory = (data) => {
                return selectedCategory && selectedCategory !== 'All'
                    ? data.filter(item => item.classification === selectedCategory)
                    : data;
            };

            const filterByClassification = (data) => {
                return selectedClassification && selectedClassification !== 'All'
                    ? data.filter(item => item.category === selectedClassification)
                    : data;
            };

            let filteredData = [];

            if (filterBy === "Likes") {
                filteredData = likedData;
            } else if (filterBy === "Dislikes") {
                filteredData = dislikedData;
            } else {
                filteredData = viewsData;
            }

            return filterByClassification(filterByCategory(filteredData));
        }
    };

    const tableData = processCategoryData(false);

    const handelCategoryFilter = (e) => {
        setSelectedCategory(e.target.value);
    };

    const handleDownloadExcel = async () => {
        if (startDate && endDate) {
            const { viewsData, dislikedData, likedData } = processCategoryData(true);
            try {
                const response = await fetch(`/api/download`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ viewsData, dislikedData, likedData, startDate, endDate, categoryData: categoryDataBlock, classificationData: classificationDataBlock }),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `From_${startDate}_to_${endDate}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            alert('Please select both start and end dates.');
        }
    };

    return (
        <>
            <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop: "20px" }}>
                KM Feedback Dashboard
            </h1>
            <div className="container">
                <div className="datepickercontainer">
                    <div className="date-picker">
                        <div className="startdate">
                            <label htmlFor="start-date-picker">Start date:</label>
                            <input
                                type="date"
                                id="start-date-picker"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="enddate">
                            <label htmlFor="end-date-picker">End date:</label>
                            <input
                                type="date"
                                id="end-date-picker"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <button disabled={!startDate && !endDate} onClick={handleDownloadExcel}>Download Excel</button>
                </div>

                {isLoading && <p>Loading...</p>}

                {submittedRange &&
                    <div className='drop'>
                        <h4>Filter Data By:</h4>
                        <div className="selector">
                            <select onChange={handelFilter} value={filterBy}>
                                {filter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }
                <div style={{ height: "20px" }}></div>
                {submittedRange &&
                    <div className='drop'>
                        <h4>Choose Category:</h4>
                        <div className="selector">
                            <select onChange={handelCategoryFilter} value={selectedCategory}>
                                {filterBy === "Likes" && likedCategoryFilter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                                {filterBy === "Dislikes" && dislikedCategoryFilter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                                {filterBy === "Views" && viewsCategoryFilter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }
                <div style={{ height: "20px" }}></div>
                {submittedRange &&
                    <div className='drop'>
                        <h4>Choose Classification:</h4>
                        <div className="selector">
                            <select onChange={handelClassificationFilter} value={selectedClassification}>
                                {filterBy === "Likes" && likedClassificationFilter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                                {filterBy === "Dislikes" && dislikedClassificationFilter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                                {filterBy === "Views" && viewsClassificationFilter.map((names, index) => (
                                    <option key={index} value={names}>
                                        {names}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }


                <div className="category-data">
                    <div style={{ "height": "10px" }}></div>
                    {submittedRange && <h4>{submittedRange}</h4>}
                    <div style={{ "height": "10px" }}></div>
                    <div className="togglescreen">
                        <label>
                            <input
                                type="checkbox"
                                checked={showName}
                                onChange={() => setshowName(!showName)}
                            />
                            Show Name
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={showCatagory}
                                onChange={() => setShowCatagory(!showCatagory)}
                            />
                            Show Category
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={showClassification}
                                onChange={() => setClassification(!showClassification)}
                            />
                            Show Classification
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={showCount}
                                onChange={() => setShowCount(!showCount)}
                            />
                            Show {filterBy || "Views"}
                        </label>
                    </div>

                    <div className="table-container">
                        <table className="category-table">
                            <thead>
                                <tr>
                                    {/* <th>Sr. No.</th> */}
                                    {showName && <th>Name</th>}
                                    {showCatagory && <th>Category</th>}
                                    {showClassification && <th>Classification</th>}
                                    {showCount && <th>{filterBy || "Views"}</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.length > 0 ? (
                                    tableData.map((category, index) => (
                                        <tr key={index}>
                                            {/* <td>{index + 1}</td> */}
                                            {showName && <td><a href={category.link} target="_blank" rel="noopener noreferrer">{category.name}</a></td>}
                                            {showCatagory && <td>{category.classification}</td>}
                                            {showClassification && <td>{category.category}</td>}
                                            {showCount &&
                                                <td>
                                                    {filterBy === "Likes" ? category.like : filterBy === "Dislikes" ? category.disslike : category.count}
                                                </td>
                                            }
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3}>No data available.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ height: "150px" }}></div>
            </div>
        </>
    );
};

export default KmFeedback;
